module.exports = __webpack_public_path__ + "img/icon_unlock.4d71e907.svg";